import { render, staticRenderFns } from "./DirectChatWelcomeHeader.vue?vue&type=template&id=07d7a06f&"
import script from "./DirectChatWelcomeHeader.vue?vue&type=script&lang=js&"
export * from "./DirectChatWelcomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./DirectChatWelcomeHeader.vue?vue&type=style&index=0&id=07d7a06f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports